import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTool, FiMonitor, FiRepeat } = FiIcons;

const features = [
  {
    icon: FiTool,
    title: 'Hands-On Technical Labs',
    text: 'Practice with tools, meters, electrical components, refrigeration equipment, air conditioning systems, and mechanical assemblies in a supervised Connecticut lab environment.',
  },
  {
    icon: FiMonitor,
    title: 'Flexible Learning Options',
    text: 'Compare classroom, evening, hybrid, modular, adult-extension, and online-supported HVAC foundations around your work or family schedule.',
  },
  {
    icon: FiRepeat,
    title: 'Licensing and Career Preparation',
    text: 'Look for training that connects theory to practical troubleshooting, EPA Section 608 preparation, Connecticut code awareness, and local employer expectations.',
  },
];

function FeatureGrid() {
  return (
    <section className="choose-section">
      <div className="section contained">
        <div className="section-heading">
          <p className="eyebrow">What to look for</p>
          <h2>Choose Training That Builds Real Technical Confidence</h2>
          <p>
            The most useful HVAC education connects theory to practice. Students
            should have opportunities to read wiring diagrams, use diagnostic
            instruments, identify system components, follow manufacturer
            procedures, and understand Connecticut licensing expectations.
          </p>
        </div>

        <div className="feature-grid">
          {features.map((feature, index) => (
            <article className={`feature-card feature-${index + 1}`} key={feature.title}>
              <SafeIcon icon={feature.icon} />
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeatureGrid;